import { ApiError } from "../../api/apiError";
import { requestErrorText, type TFunction } from "../queue/requestErrorText";
import {
  HTTP_BAD_GATEWAY,
  HTTP_CONFLICT,
  HTTP_FORBIDDEN,
  HTTP_UNAUTHORIZED,
  HTTP_UNPROCESSABLE_ENTITY,
} from "./api";

const KEYS = "connections.ciLogs.errors";

// Тексты отказов `ci-logs` по паре статус + код (ADR-0091 § 7); коды —
// docs/spec/modules/ci_log.md и ядро (`permission_denied`).
const REFUSAL_MESSAGE_KEYS: readonly (readonly [number, string, string])[] = [
  [HTTP_UNAUTHORIZED, "credentials_rejected", `${KEYS}.credentialsRejected`],
  [HTTP_FORBIDDEN, "host_not_allowed", `${KEYS}.hostNotAllowed`],
  [HTTP_FORBIDDEN, "permission_denied", `${KEYS}.forbidden`],
  [HTTP_CONFLICT, "log_api_unsupported", `${KEYS}.logApiUnsupported`],
  [HTTP_UNPROCESSABLE_ENTITY, "invalid_request_body", `${KEYS}.invalidBody`],
  [HTTP_UNPROCESSABLE_ENTITY, "provider_unknown", `${KEYS}.providerUnknown`],
  [HTTP_UNPROCESSABLE_ENTITY, "invalid_host_url", `${KEYS}.invalidHostUrl`],
  [
    HTTP_UNPROCESSABLE_ENTITY,
    "invalid_credentials",
    `${KEYS}.invalidCredentials`,
  ],
  [HTTP_BAD_GATEWAY, "unreachable", `${KEYS}.unreachable`],
];

// Человекочитаемый текст отказа ручек `ci-logs`: по паре статус + код,
// прочее — по статусу ответа либо «нет связи». Технический `message` и
// текст сервера не выводятся.
export function describeCiLogError(err: unknown, t: TFunction): string {
  if (err instanceof ApiError) {
    const entry = REFUSAL_MESSAGE_KEYS.find(
      ([status, code]) => status === err.status && code === err.code,
    );
    if (entry !== undefined) return t(entry[2]);
  }
  return requestErrorText(err, t);
}
